/**
 * A tenant's "Estimated Sales" is typed in as free text (MYD-516). A plain
 * number, with or without "$" and commas, reads as an amount to format as
 * dollars; anything else ("$1.2M", "n/a") is shown exactly as entered.
 *
 * @returns the amount, or null when the value is not a plain number
 */
export const salesAmount = (value: unknown): number | null => {
	const cleaned = String(value ?? '').replace(/[$,\s]/g, '')
	if (!/^\d+(\.\d+)?$/.test(cleaned)) return null
	return Number(cleaned)
}

export default salesAmount
